import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { DataGrid } from "@mui/x-data-grid";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { validatePermission } from "../../../../utils/permissionUtils";
import { usePermissions } from "../../../../context/permissionContext";
import Loader from "../../../../components/Loader/Loader";
import "../../../../components/common/css/datatable.scss";

const Otherscontent = () => {
  const [query, setQuery] = useState("");
  const [data, setData] = useState([]);
  const [status, setStatus] = useState([]);
  const [loading, setLoading] = useState(false);
  const { permissions, permissionsMapping } = usePermissions();
  
  
  const search = (data) => {
    return data?.filter(
      (item) =>
        item?.category_name?.toLowerCase()?.includes(query) ||
        item?.category_title?.toLowerCase()?.includes(query) ||
        item?.category_description?.toLowerCase()?.includes(query)
    );
  };

  const hasEditPermission = validatePermission(
    "Pages - Categories:Edit",
    permissions,
    permissionsMapping
  );
  const hasDeletePermission = validatePermission(
    "Pages - Categories:Delete",
    permissions,
    permissionsMapping
  );


  const deleteFunction = (id) => {
    const token = localStorage.getItem("accessToken");
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        var config = {
          method: "delete",
          url: process.env.REACT_APP_API + "remove-business-category",
          headers: {
            "x-access-token": token,
          },
          data: {
            category_id: id,
          },
        };
        axios(config)
          .then(function (res) {
            if (res.status == 200) {
              Swal.fire("Deleted!", "Your file has been deleted.", "success");
              fetchcategorydata();
              setLoading(false);
            }
          })
          .catch(function (error) {
            setLoading(false);
            console.log(error);
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        setLoading(false);
        Swal.fire("Cancelled", "Your data is safe", "error");
      }
    });
  };

  const fetchcategorydata = () => {
    setLoading(true);
    var config = {
      method: "get",
      url: process.env.REACT_APP_API + "get-categories",
    };

    axios(config)
      .then(function (response) {
        setData(response.data.data);
        setStatus({ value: response?.data?.data?.category_status });
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error.response.data.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  useEffect(() => {
    fetchcategorydata();
  }, []);

  useEffect(() => {}, [status]);

  const statusColumn = [
    {
      field: "status",
      headerName: "Status",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <span
              className={`status ${
                params.row.category_status == 0 ? "Approved" : "Pending "
              }`}
            >
              {params.row.category_status == 0 ? "Active" : "Inactive"}
            </span>
          </div>
        );
      },
    },
  ];

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Link
              to={`/categories/${params.row.id} `}
              style={{ textDecoration: "none" }}
            >
              <div className="viewButton">
                <RemoveRedEyeOutlinedIcon />
              </div>
            </Link>
            {hasEditPermission && <Link
              to={`/categories/edit/${params.row.id} `}
              style={{ textDecoration: "none" }}
            >
              <div className="editButton">
                <EditOutlinedIcon />
              </div>
            </Link>}
            {hasDeletePermission && <div
              className="deleteButton"
              onClick={() => deleteFunction(params.row.id)}
            >
              <DeleteOutlineIcon />
            </div>}
          </div>
        );
      },
    },
  ];

  const userColumns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "category_name",
      headerName: "Name",
      width: 200,
    },
    {
      field: "category_title",
      headerName: "Title",
      width: 200,
    },
    {
      field: "category_description",
      headerName: "Description",
      width: 200,
    },
  ];

  return (
    <div className="datatable">
      <Loader isLoading={loading} />
      <div className="datatableTitle">
        <div className="tablesearch">
          <input type="text" placeholder="Search..." onChange={(e) => setQuery(e.target.value)}/>
          <SearchOutlinedIcon className="sarchicon" />
        </div>
        <h5 style={{ marginLeft: "-10%" }}>Category</h5>
        {hasEditPermission && <Link to="/categories/add-category" className="link">
          Add New
        </Link>}
      </div>
      <DataGrid
        className="datagrid"
        rows={search(data)}
        columns={userColumns.concat(statusColumn, actionColumn)}
        pageSize={9}
        rowsPerPageOptions={[9]}
      />
    </div>
  );
};

export default Otherscontent;
